import { render, staticRenderFns } from "./HumanService.vue?vue&type=template&id=8a6bda9a&scoped=true"
import script from "./HumanService.vue?vue&type=script&lang=js"
export * from "./HumanService.vue?vue&type=script&lang=js"
import style0 from "./HumanService.vue?vue&type=style&index=0&id=8a6bda9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6bda9a",
  null
  
)

export default component.exports